export const vueAppDomin = process.env.VUE_APP_DOMIN
export const vueAppPassportApi = process.env.VUE_APP_PASSPORT_API
export const vueAppPassportDomin = process.env.VUE_APP_PASSPORT_DOMIN
export const vueAppBaseApi = process.env.VUE_APP_BASE_API
export const vueAppStaticSite = process.env.VUE_APP_STATIC_SITE

export default {
  vueAppDomin,
  vueAppPassportApi,
  vueAppPassportDomin,
  vueAppBaseApi,
  vueAppStaticSite
}
